import { render, staticRenderFns } from "./cartridge.vue?vue&type=template&id=c6524366&"
import script from "./cartridge.vue?vue&type=script&lang=js&"
export * from "./cartridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6524366')) {
      api.createRecord('c6524366', component.options)
    } else {
      api.reload('c6524366', component.options)
    }
    module.hot.accept("./cartridge.vue?vue&type=template&id=c6524366&", function () {
      api.rerender('c6524366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-list/cartridge.vue"
export default component.exports